(function (w, doc, undefined) {
	'use strict';

	let ARIAaccordion = {};
	w.ARIAaccordion = ARIAaccordion;

	let widgetClass = 'rs-accordion';
	let widgetHeadingClass = widgetClass + '__heading';
	let widgetTriggerClass = widgetClass + '__trigger';
	let widgetPanelClass = widgetClass + '__panel';

	let widgetHeading = '[data-aria-accordion-heading]';
	let widgetPanel = '[data-aria-accordion-panel]';

	let idCounter = 0;

	let keys = {
		end: 35,
		home: 36,
		up: 38,
		down: 40
	};

	let direction = {
		38: -1,
		40: 1
	};

	/**
	 * Create object.
	 */
	ARIAaccordion.create = function () {
		let self;
		let panels;
		let headings;
		let triggers;
		let defaultPanel;
		let constantPanel;
		let multiPanel;
		let i;

		let widget = doc.querySelectorAll('[data-component="data-aria-accordion"]');

		idCounter += 1;

		for (i = 0; i < widget.length; i++) {
			self = widget[i];
			let t;

			// Setup accordion component ID
			if (!self.hasAttribute('id')) {
				self.id = 'acc_' + idCounter + '-' + i;
			}

			// Add accordion component class
			self.classList.add(widgetClass);

			// Determine default accordion panel to display
			if (self.hasAttribute('data-default')) {
				defaultPanel = self.getAttribute('data-default');
			} else {
				defaultPanel = 1;
			}

			// Determine if accordion should always have a panel open
			constantPanel = self.hasAttribute('data-constant');

			// Determine if accordion can have multiple panels open at a time
			multiPanel = self.hasAttribute('data-multi');

			// Get existing panels & headings
			panels = doc.querySelectorAll('#' + self.id + ' ' + widgetPanel);
			headings = doc.querySelectorAll('#' + self.id + ' ' + widgetHeading);

			// Setup panels & buttons.
			ARIAaccordion.setupPanels(self.id, panels, defaultPanel);
			ARIAaccordion.setupButtons(self.id, headings, defaultPanel, constantPanel);

			// Get current triggers
			triggers = doc.querySelectorAll('#' + self.id + ' .' + widgetTriggerClass);

			// Setup trigger events
			for (t = 0; t < triggers.length; t++) {
				triggers[t].addEventListener('click', ARIAaccordion.clickEventListener);
				triggers[t].addEventListener('keydown', ARIAaccordion.keydownEventListener);
			}
		}
	}; // ARIAaccordion.create()

	/**
	 * Setup accordion panels.
	 */
	ARIAaccordion.setupPanels = function (id, panels, defaultPanel) {
		let i;
		let panel;
		let panelID;

		for (i = 0; i < panels.length; i++) {
			panel = panels[i];

			// Add panel id
			panelID = id + '_panel_' + (i + 1);
			panel.setAttribute('id', panelID);

			// Add panel class
			panel.classList.add(widgetPanelClass);

			// Add aria role
			panel.setAttribute('role', 'region');

			// Add aria-labelledby
			panel.setAttribute('aria-labelledby', panelID + "_trigger");

			// Un-hide default panel
			panel.hidden = i !== defaultPanel - 1;

		}
	}; // ARIAaccordion.setupPanels

	/**
	 * Setup accordion buttons.
	 */
	ARIAaccordion.setupButtons = function (id, headings, defaultPanel, constantPanel) {
		let i;
		let heading;
		let newButton;
		let buttonText;
		let buttonID;

		for (i = 0; i < headings.length; i++) {
			heading = headings[i];
			buttonID = id + '_panel_' + (i + 1);

			// Add heading class
			heading.classList.add(widgetHeadingClass);

			// Create new button
			newButton = doc.createElement('button');
			buttonText = heading.textContent;
			heading.innerHTML = '';

			// Add the heading text
			heading.appendChild(newButton);
			newButton.appendChild(doc.createTextNode(buttonText));

			// Add button id
			newButton.setAttribute('id', buttonID + '_trigger');

			// Add button class
			newButton.classList.add(widgetTriggerClass);

			// Add aria-labelledby
			newButton.setAttribute('aria-controls', buttonID);

			// Determine default panel
			if (i === defaultPanel - 1) {
				// Expand the default panel
				newButton.setAttribute('aria-expanded', 'true');

				if (constantPanel) {
					// Prevent this panel being closed unless another opened
					newButton.setAttribute('aria-disabled', 'true');
				}
			} else {
				newButton.setAttribute('aria-expanded', 'false');
			}
		}
	}; // ARIAaccordion.setupButtons

	/**
	 * Handle click event.
	 */
	ARIAaccordion.clickEventListener = function (event) {
		let thisTrigger = event.target;

		// Get ID for this accordion component
		let thisAccordionID = this.id.replace(/_panel.*$/g, '');

		// Get all related triggers
		let triggers = doc.querySelectorAll('#' + thisAccordionID + ' .' + widgetTriggerClass);

		ARIAaccordion.togglePanel(thisTrigger, true, thisAccordionID, triggers);
	}; // ARIAaccordion.clickEventListener

	/**
	 * Handle keydown event.
	 */
	ARIAaccordion.keydownEventListener = function (event) {
		let key = event.keyCode;

		// Get ID for this tabs component
		let thisAccordionID = this.id.replace(/_panel.*$/g, '');

		// Get all related triggers
		let thisTriggers = doc.querySelectorAll('#' + thisAccordionID + ' .' + widgetTriggerClass);

		switch (key) {
			case keys.end:
				event.preventDefault();
				// Move focus to last trigger
				thisTriggers[thisTriggers.length - 1].focus();
				break;
			case keys.home:
				event.preventDefault();
				// Move focus to first trigger
				thisTriggers[0].focus();
				break;

			case keys.up:
			case keys.down:
				ARIAaccordion.switchFocusOnArrowPress(event, thisTriggers);
				break;
		}
	}; // ARIAaccordion.keydownEventListener

	/**
	 * Handle switching focus based on arrow keys pressed.
	 */
	ARIAaccordion.switchFocusOnArrowPress = function (event, thisTriggers) {
		let pressed = event.keyCode;

		if (direction[pressed]) {
			let target = event.target;
			let targetID = target.getAttribute('id');

			let currentIndex;
			let targetIndex;

			// Get position of target in triggers array
			thisTriggers.forEach((nodes, index) => {
				if (nodes.id.indexOf(targetID) !== -1) {
					currentIndex = index;
				}
			});

			targetIndex = currentIndex + direction[pressed];

			if (targetIndex !== undefined) {
				if (thisTriggers[targetIndex]) {
					// Move focus to next ore previous trigger (if exists)
					thisTriggers[targetIndex].focus();
				} else if (pressed === keys.left || pressed === keys.up) {
					// Move focus to last trigger
					thisTriggers[thisTriggers.length - 1].focus();
				} else if (pressed === keys.right || pressed === keys.down) {
					// Move focus to first trigger
					thisTriggers[0].focus();
				}
			}
		}
	};

	/**
	 * Toggles a panel.
	 */
	ARIAaccordion.togglePanel = function (thisTrigger, setFocus, thisAccordionID, triggers) {
		setFocus = setFocus || true;

		let constant = doc.getElementById(thisAccordionID).hasAttribute('data-constant');
		let multi = doc.getElementById(thisAccordionID).hasAttribute('data-multi');

		let thisPanelID = thisTrigger.getAttribute('aria-controls');
		let panelID;

		let i;

		// Prevent action on disabled trigger
		if (thisTrigger.getAttribute('aria-disabled') !== 'true') {

			if (thisTrigger.getAttribute('aria-expanded') === 'false') {

				// Update other triggers
				for (i = 0; i < triggers.length; i++) {
					if (thisTrigger !== triggers[i]) { // exclude current

						if (!multi) { // Close others
							triggers[i].setAttribute('aria-expanded', 'false');

							panelID = triggers[i].getAttribute('aria-controls');
							doc.getElementById(panelID).setAttribute('hidden', '');
						}

						if (constant) {
							// Cancel the previous 'can't be closed' panel
							triggers[i].removeAttribute('aria-disabled');
						}
					}
				}

				// Set expanded to true for this trigger
				thisTrigger.setAttribute('aria-expanded', 'true');

				if (constant) {
					// This panel now becomes the one that 'can't be closed'
					thisTrigger.setAttribute('aria-disabled', 'true');
				}

				// Remove hidden attribute from corresponding panel
				doc.getElementById(thisPanelID).removeAttribute('hidden');

				// Set focus if required
				if (setFocus) {
					thisTrigger.focus();
				}

			} else {
				thisTrigger.setAttribute('aria-expanded', 'false');

				// Add hidden attribute to panel
				doc.getElementById(thisPanelID).setAttribute('hidden', '');
			}
		}
	}; // ARIAaccordion.togglePanel

	ARIAaccordion.init = function () {
		ARIAaccordion.create();
	};

	ARIAaccordion.init();

})(window, document);
